// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"71fe2a0c","460":"b547fe56","891":"d8cc60e0"}[chunkId] + ".chunk.js";
};